// assets/edore.js
(function () {
  const modal = document.getElementById('edoreModal');
  if (!modal) return;

  const open = () => modal.classList.add('is-open');
  const close = () => modal.classList.remove('is-open');

  document.addEventListener('click', (e) => {
    // Открытие по любому клику на ссылку/кнопку с href="#edore" или data-edore-open
    const a = e.target.closest('a');
    const opener = e.target.closest('[data-edore-open]');

    if (opener) {
      e.preventDefault();
      open();
      return;
    }

    if (a && a.getAttribute('href') === '#edore') {
      e.preventDefault();
      open();
      return;
    }

    // Закрытие
    const closer = e.target.closest('[data-edore-close]');
    if (closer) {
      e.preventDefault();
      close();
      return;
    }

    if (e.target.classList.contains('edore-modal__backdrop')) {
      close();
      return;
    }
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') close();
  });
})();